import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import {
  EndPointUserDetails,
  GET_NOTIFICATIONCARDS_LIST,
} from "../../services/common/endpoints";
import {
  GetCacheKey,
  GetHomeGreetText,
  getItemOfSessionStorage,
  isContainAlphabet,
  getGlobalSettingValue
} from "../../services/common/utils";
import Loadingcomponent from "../loader/loadingcomponent";
import {setNotificationData, setNotificationsArray} from "../../reducer/actions"
import ErrorMessage from "../messaging/errormessage";
import { setPhoneNumber, setisPrepaid, setrnuserdetails } from "../../reducer/actions";
import { useTranslation } from "react-i18next";
import { redirecturl } from "../../services/common/redirect";
import { useNavigate } from "react-router-dom";
import { SELECTED_LANG, SHOW_ALERT_KEY } from "../../services/common/Constants";
import { useSelector, useDispatch } from "react-redux";

const NotificationComponent = ({ pmsitem, isTheme }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const [notifications, setNotifications] = useState([]);
  const [userDetails, setuserDetails] = useState(null);
  const [isBirthDay, setIsBirthDay] = useState(false);
  const [notificationIndex, setnotificationIndex] = useState(0);
  const dispatch = useDispatch();
  const notificationsArray = useSelector((state) => state?.userdata?.notificationsArray);
  const {
    utilityData: { showNotificationAndProfile }
} = useSelector((state) => state);
  const {
    userdata: { showNotificationGreetingSection },
  } = useSelector((state) => state);
  //close notification
  const closeNotification = (data) => {    
      if(notificationsArray?.length > 0){
        dispatch(setNotificationsArray({type:"delete", data: data}));
      }
  };

  // const navigate = useNavigate()
  const notificationsApi = useQuery(
    [
      GetCacheKey("notifications"),
      pmsitem.method,
      JSON.parse(pmsitem.sourceid),
      {},
    ],
    {
      retry: false,
      retryOnMount: false,
      cacheTime: 0,
      staleTime: 0,
      onSuccess: (userData) => {
        try{
          if(userData?.data?.status !== "-1" && userData?.data !== ""){
            let [temp] = userData?.data?.response;
            dispatch(setNotificationsArray("clearNotification"));
            dispatch(setNotificationsArray({type: "rnnotication", data: temp}));
          }
        }catch{}
      },
    }
  );

  useEffect(()=>{
    // notificationsApi.refetch();
    console.log("------------------------------------",notificationsArray)
    
  }, [notificationsArray])

  const userdetailsApi = useQuery(
    ["", EndPointUserDetails.url, EndPointUserDetails.data, {}],
    {
      retry: false,
      retryOnMount: false,
      cacheTime: 0,
      staleTime: 0,
      onSuccess: (userData) => {
        setuserDetails(userData.data.response);
        dispatch(setrnuserdetails(userData.data.response))
      },
    }
  );

  const {
    utilityData: { globalSetting },
  } = useSelector((state) => state);

  const settingsArr = globalSetting
    ? globalSetting?.Globalsettings[0]?.items[0]?.metadata
  : [];
  useEffect(() => {
    try {
      if (
        userDetails !== null &&
        userDetails.dob.split("/")[0] == new Date().getDate() &&
        userDetails.dob.split("/")[1] == new Date().getMonth() + 1
      ) {
        setIsBirthDay(true);
      }
    } catch (e) {}
  }, [userDetails]);
  // const nicnameText = () => {

  //     if (getItemOfSessionStorage(SELECTED_LANG) === 'en') {
  //         return userDetails?.nickname !== null && `${userDetails?.nickname} ${t("number")}`;
  //     } else {
  //         if (isContainAlphabet(userDetails?.nickname)) {
  //             return userDetails?.nickname !== null && `${userDetails?.nickname} ${t("number")}`;
  //         } else {
  //             return userDetails?.nickname !== null && `${t("number")} ${userDetails?.nickname}`
  //         }
  //     }
  // }

  const nicnameText = () => {
    if (getItemOfSessionStorage(SELECTED_LANG) === "en") {
      return userDetails?.nickname !== null ? userDetails?.nickname : "";
    } else {
      if (isContainAlphabet(userDetails?.nickname)) {
        return userDetails?.nickname !== null ? userDetails?.nickname : "";
      } else {
        return userDetails?.nickname !== null ? userDetails?.nickname : "";
      }
    }
  };
  console.log(nicnameText(), "nicnameText");
  // console.log(isContainAlphabet(userDetails?.nickname), "isContainAlphabet(userDetails?.nickname)")
  const handleRedirect = (e, url, notificationType) => {
    e.preventDefault();
    if(url?.indexOf("https://") === 0){
      window.open(url, "_blank")
    }else{
    redirecturl(url, navigate, null, null, notificationType); 
    }
  };

  // console.log(userDetails, "userDetails?")

  // if(notificationsApi?.data?.data?.status === '-1'){
  //   return <></>
  // }

  return (
    <div className="">
      {/* Apply 'no_alerts' class to app_alerts_wrap : when no alerts found*/}
      {notificationsApi?.isLoading || notificationsApi?.isFetching ? (
        // <Loadingcomponent />
        <></>
      ) : (
        <div className={`${notificationsArray?.length > 0 ? 'app_alerts_wrap' : ''}`}>
        <ul className={`${showNotificationGreetingSection ? 'app_alerts_list8' : 'app_alerts_list'}`}>
          {/* {console.log(notifications, "notificationsApisss")} */}
          {(notificationsArray?.length > 0) &&
            notificationsArray?.map((x, index) => {
              return (
                <li className="app_alert_card">
                  <button
                    className="alert_close img_btn btn_trigger"
                    onClick={() => closeNotification(x?.data)}
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL + "/assets/images/cross_dark.svg"
                      }
                      alt=""
                      title=""
                    />
                  </button>
                  {x?.data?.title == "Internet" ? 
                    <h3 className="d-flex app_alert_title text-ellipsis" dir="ltrl">
                      <div class="me-2">
                        {x?.data?.img && <span><img width="47px" height="47px" src={x?.data?.img}/></span>}
                      </div>
                      {x?.data?.title}
                    </h3> 
                    :
                    <h3 className=" d-flex app_alert_title text-ellipsis" dir="ltrl">
                      <div class="me-2">
                        {x?.data?.img && <span><img with="47px" height="47px" src={x?.data?.img}/></span>}
                      </div>
                      {`${x?.type === 'rnnotication' ? GetHomeGreetText(t) +" " : ''}` }
                      {x?.data?.title ?
                        (x?.data?.title === "!USERTEXT!" && !nicnameText()) ? '' : x?.data?.title?.replace("!USERTEXT!", nicnameText()) 
                        : ""}
                    </h3>
                  }       
                  <p className="app_alert_desc"> {x?.data?.desc}</p>
                  <div
                    className="hyperlink align-self-end text-initials"
                    onClick={(e) =>
                      handleRedirect(e, x?.data?.redirect, x?.data?.notificationtype)
                    }
                  >
                    {x?.data?.button}
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/right_arrow_red.svg"
                      }
                      alt=""
                      title=""
                    />
                  </div>
                </li>
              );
            })}
        </ul>
      </div>
      )}
      <div>
        {userdetailsApi?.isLoading || userdetailsApi?.isFetching ? (
         <> 
         {/* <div class="flex_grp_between mb-5">
            <div class="flex_grp_align_center flex1">
             <div class="ms-2 shimmerBG shimmer-icon-lg m-0">
             </div>
             <h3 class="section_title_light mb-0 shimmerBG shimmer-sec-heding w-50 h-5 m-2"></h3>
         </div>
      </div> */}
     </>
        ) : userDetails === null || userDetails === undefined || userDetails === '' ? (
          //FOR HE AND WIFI CASE, IF SSO PROFILE IS NOT EXIST SHOWING ONLY GREETING TEXT INSTEAD OF ERROR BLOCK
          //THIS WILL APPLICABLE FOR ALL CASE, WHEN RNUSERPROFILE IS FAILED, SHOWING ONLY GREETING TEXT

          // <div className="xpress_no_trans text-center" >
          //     <img
          //         src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
          //         alt=""
          //         title=""
          //     />
          //     <div className="mb-5">
          //         <label>{t("somethingwentwrong")}</label>
          //     </div>
          // </div>
          <>
          {
            showNotificationGreetingSection && (!isTheme || showNotificationAndProfile) && (
          <div className="profile_info mb-4">
            <div className="profile_info_img">
              <img
                src={process.env.PUBLIC_URL + "/assets/images/sprint16/ooredoo-sm-logo.svg"}
                alt=""
                title=""
              />
            </div>
            <div className="profile_info_desc">
              <h3 className="message section_title mb-0 text-ellipsis">
                {GetHomeGreetText(t)}
              </h3>
            </div>
          </div>
        )
        }
        </>
      ) : (
      <>
      {
        showNotificationGreetingSection && (!isTheme || showNotificationAndProfile) && (
          <div className="profile_info mb-4">
            <div className="profile_info_img">
              <img
                src={
                  userDetails?.profilepic === ""
                    ? process.env.PUBLIC_URL + "/assets/images/user.png"
                    : userDetails?.profilepic
                }
                alt=""
                title=""
              />
            </div>
            <div
              className={
                getItemOfSessionStorage(SELECTED_LANG) === "en"
                  ? "profile_info_desc"
                  : "profile_info_desc_rtl"
              }
            >
              <h3 className="message section_title mb-0 text-ellipsis">
                {isBirthDay ? `${t("hb")},` : GetHomeGreetText(t)}
              </h3>
              <h1 className="profile_name text-ellipsis" dir="ltrl">
                {nicnameText()}
              </h1>
            </div>
            {isBirthDay && (
              <div className="event_img bod-gift-image">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/blast.svg"}
                  alt=""
                  title=""
                />
              </div>
            )}
            { getGlobalSettingValue('homeflagimage_web', settingsArr) && <div class="event_img">
              <img 
                src={getGlobalSettingValue('homeflagimage_web', settingsArr)}
                alt="" title="" class="image-comp"
              />
            </div>}
          </div>
          )
        }
        </>
        )}
      </div>
    </div>
  );
};
export default NotificationComponent;
